export const COLORS = {
  normal: '#d00000',
  selected: '#f07b5d',
};
